module.exports = __webpack_public_path__ + "static/media/6.10c711f2.jpg";